import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface ListingVideoResource {
  id: number;
  url: string;
  name: string;
  fileSize: number;
  length: number;
  title: string;
  author: string;
}

export default (makeCall: MakeCall) => (listingId: number) =>
  makeCall<ListingVideoResource[]>(
    'GET',
    `${APIV2_URL}/listing/${listingId}/videos`,
  );
